import { Component, Input, Inject } from "@angular/core";
import { FlowTemplate, Transition, SideEffect, LoadFromDatabaseConfig } from "../../../../common/models/flow.dto";
import { EntityMap } from "../../../models/entity.model";
import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./models/types";

@Component({
    selector: "side-effect-loaddatabase",
    templateUrl: "side-effect-loaddatabase.component.html",
    standalone: false
})
export class SideEffectLoadDatabaseComponent {
    transition: Transition;
    sideEffect: SideEffect;
    template: FlowTemplate;

    selectedMappings = new Array<EntityMap>();

    get showEntityMaps(): boolean {
        if (this.template && this.template.entityMaps)
            return this.template.entityMaps.length > 0;

        return false;
    }

    get entityMaps(): Array<EntityMap> {
        if (this.template === undefined ||
            this.template === null ||
            this.template.entityMaps === undefined ||
            this.template.entityMaps === null) {
            return new Array<EntityMap>();
        }

        return this.template.entityMaps;
    }

    constructor(
        @Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData
    ) {
        this.sideEffect = data.sideEffect;
        this.transition = data.transition;
        this.template = data.template;
    }

    checkChanged(mapId: string): void {
        if (this.sideEffect.configuration === undefined || this.sideEffect.configuration === null) {
            this.sideEffect.configuration = { entityMapIds: [] } as LoadFromDatabaseConfig;
        }
        if (this.configHasMapping(mapId)) {
            const map = this.template.entityMaps.find(m => m.id === mapId);
            const bubble = new Array<string>();
            for (let i = 0; i < this.sideEffect.configuration.entityMapIds.length; i++) {
                let doAdd: boolean = true;
                if (this.sideEffect.configuration.entityMapIds[i] !== mapId) {
                    if (map && map.relatedEntityMaps) {
                        const related = map.relatedEntityMaps.find(m => m.id === this.sideEffect.configuration.entityMapIds[i]);
                        if (related) doAdd = false;
                    }
                }
                if (doAdd)
                    bubble.push(this.sideEffect.configuration.entityMapIds[i]);
            }
            this.sideEffect.configuration.entityMapIds = bubble;
        } else
            this.sideEffect.configuration.entityMapIds.push(mapId);

    }

    configHasMapping(id: string): boolean {
        if (this.sideEffect.configuration === undefined || this.sideEffect.configuration === null) 
            return false;

        const exists = this.sideEffect.configuration.entityMapIds.find(t => t === id);

        return (exists !== undefined && exists !== null);
    }

    mapHasSubordinates(map: EntityMap): boolean {
        return (map.relatedEntityMaps && map.relatedEntityMaps.length > 0);
    }
}